export const ApplicationConstant = {
    ApplicationID : 41,
    clientId : 29,
    organizationId: 441,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 40,
    authStrategy : 'SINGLE_SIGN_ON'
}